import classNames from 'classnames';
import { t } from 'ttag';

import { Switch } from '@ui/Switch';

import s from './WorkingStatusSettings.sss';

type WorkingStatusSettingsProps = {
  isUserWorking: boolean
  onChange: (isUserWorking: boolean) => void
  className?: string
};

export const WorkingStatusSettings: React.FC<WorkingStatusSettingsProps> = ({
  isUserWorking,
  onChange,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <div className={s.leftSide}>
      <div className={s.title}>
        {t`Я приймаю замовлення`}
      </div>
      <div className={s.description}>
        {t`Увімкніть цю опцію, якщо ви готові працювати зараз та приймати замовлення (через чат або через "Купити")`}
      </div>
    </div>
    <Switch
      className={s.switch}
      checked={isUserWorking}
      onChange={() => onChange(!isUserWorking)}
    />
  </div>
);
